<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('productPallet.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('productPallet.pageTitle'),
            active: true,
          },
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between">
					<div class="ts-space-x-3">						
						<ts-button outline color="info" @click.prevent="update">{{
							$t('update')
						}}</ts-button>
					</div>
          <div class="d-flex ts-space-x-3 ts-items-center">
            <ts-input
              v-model="search"
              :placeholder="$t('search')"
              v-tooltip="$t('productPallet.search')"
              style="width: 250px"
              class="inline-block"
            />
          </div>
        </div>
      </ts-card-wrapper>
      <ts-table
        :columns="columns"
        :records="resources"
        :loading="loading"
      >
        <template v-slot="{ record }">
          <td>{{ record.barcode }}</td>
          <td>{{ record.product_name_en }}</td>
          <td class="ts-text-center">{{ record.uom_name_en }}</td>
          <td class="ts-text-center">{{ record.quantity_per_pallet }}</td>
          <td class="ts-text-center">{{ record.qty_foc_per_x_unit }}</td>
        </template>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'

export default {
  name: 'productPallet',
  data() {
    return {
      loading: false,
			waiting: false,
    }
  },
  computed: {
    ...mapState('product/pallet', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.product.pallet.search
      },
      set(newValue) {
        this.$store.commit('product/pallet/SET_SEARCH', newValue)
        this.$store.commit('product/pallet/RESET_CURRENT_PAGE')
      },
    },
    columns() {
      return [
        { name: this.$t('productPallet.barcode'), style: 'width: 3%' },
        { name: this.$t('productPallet.productName') },
        { name: this.$t('productPallet.uomName'), style: 'width: 3%; text-align:center' },
        { name: this.$t('productPallet.qtyPerPallet'), style: 'width: 3%; text-align:center' },
        { name: this.$t('productPallet.qtyFocPerXUnit'), style: 'width: 3%; text-align:center' },
      ]
    },
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('product/pallet/fetch', { ...attributes })
        .then((response) => {
          this.loading = false
        })
        .catch((error) => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    update() {
      this.$router.push({ name: 'product-pallet-edit' })
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData()
    }, 500),
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('product/pallet/RESET_STATE')
    next()
  },
	beforeRouteEnter(to, from, next) {
		next(vm => {
			vm.fetchData()
		})
	}
}
</script>
